<template>
    <v-container fluid>
        <v-stepper :value="step" @change="gotoStepNumber" non-linear width="100%" class="problem-edit">
            <v-stepper-header>
                <template v-for="stepData in steps">
                    <v-stepper-step
                        :editable="isStepEditable(stepData)"
                        :complete="isStepFinished(stepData)"
                        :step="stepData.step"
                        :key="'s'+stepData.code"
                    >{{stepData.title}}</v-stepper-step>
                    <v-divider :key="'d'+stepData.code"></v-divider>
                </template>
            </v-stepper-header>
            <v-stepper-items>
                <v-stepper-content step="1" class="pa-0">
                    <steps-form v-model="item" :editState="editState" @next_step="gotoNextStep" @list="gotoList"></steps-form>
                </v-stepper-content>
                <v-stepper-content step="2" v-if="item && item.type === 'wells'">
                    <adapt-settings v-model="wellsTask" task-type="wells" v-if="step === 2"></adapt-settings>
                    <v-btn v-if="wellsTask && wellsTask.id && wellsTask.status === 'finished'"
                        large color="primary" @click="gotoNextStep" class="mt-4">Посмотреть результаты</v-btn>
                    <v-btn v-else-if="wellsTask && wellsTask.id && wellsTask.status === 'error'"
                           large color="primary" @click="saveTaskAndGotoNextStep" class="mt-4">Обновить параметры и перезапустить</v-btn>
                    <v-btn v-else
                        large color="primary" @click="saveTaskAndGotoNextStep" class="mt-4">Далее</v-btn>
                </v-stepper-content>
                <v-stepper-content step="2" v-else>
                    <adapt-settings v-model="task" task-type="optimize" v-if="step === 2"></adapt-settings>
                    <v-btn v-if="task && task.id && task.status === 'finished'"
                           large color="primary" @click="gotoNextStep" class="mt-4">Посмотреть результаты</v-btn>
                    <v-btn v-else-if="task && task.id && task.status === 'error'"
                           large color="primary" @click="saveTaskAndGotoNextStep" class="mt-4">Обновить параметры и перезапустить</v-btn>
                    <v-btn v-else
                           large color="primary" @click="saveTaskAndGotoNextStep" class="mt-4">Далее</v-btn>
                </v-stepper-content>
                <v-stepper-content step="3" v-if="item && item.type === 'wells'">
                    <adapt-result :item="item" :task="wellsTask" v-if="wellsTaskFinished" @predict="gotoNextStep"></adapt-result>
                    <task-progress :task="wellsTask" :visible="step === 3" v-else></task-progress>
                </v-stepper-content>
                <v-stepper-content step="3" v-else>
                    <adapt-result :item="item" :task="task" v-if="taskFinished && step === 3" @predict="gotoNextStep"></adapt-result>
                    <task-progress :task="task" :visible="step === 3" v-else></task-progress>
                </v-stepper-content>
                <v-stepper-content step="4" v-if="item && item.type === 'wells'">
                    <adapt-result :item="item" :task="predictTask" :optimize-task="wellsTask" v-if="predictTaskFinished && step === 4"></adapt-result>
                    <task-progress :task="predictTask" :visible="step === 4" v-else-if="predictTask && predictTask.id"></task-progress>
                    <predict-settings v-model="predictTask" v-else></predict-settings>
                    <v-btn large color="primary" @click="savePredictTask" class="mt-4" v-if="!(predictTask && predictTask.id)">Далее</v-btn>
                </v-stepper-content>
                <v-stepper-content step="4" v-else>
                    <adapt-result :item="item" :task="predictTask" :optimize-task="task" v-if="predictTaskFinished && step === 4"></adapt-result>
                    <task-progress :task="predictTask" :visible="step === 4" v-else-if="predictTask && predictTask.id"></task-progress>
                    <predict-settings v-model="predictTask" v-else></predict-settings>
                    <v-btn large color="primary" @click="savePredictTask" class="mt-4" v-if="!(predictTask && predictTask.id)">Далее</v-btn>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
    </v-container>
</template>

<script>
import AdaptResult from "@/components/Panels/AdaptResultNew.vue";
import StepsForm from "@/components/Problem/Steps/NewDataStepsForm";
import AdaptSettings from "@/components/Problem/AdaptSettings.vue";
import PredictSettings from "@/components/Problem/PredictSettings.vue";
import TaskProgress from "@/components/Problem/TaskProgress.vue";
import clone from "lodash.clonedeep";

export default {
    components: {AdaptResult, StepsForm, AdaptSettings, TaskProgress, PredictSettings},
    data() {
        return {
            item: {},
            editState: {},
            task: {},
            predictTask: {},
            wellsTask: {},
            tab: 'upload',
            uploadType: 'file',
            files: [],
            uploadedFiles: [],
            isSelectingFiles: false,
            ACTION_LOAD: 'problem/loadItems',
            ACTION_NEW: 'problem/newItem',
            ACTION_SAVE: 'problem/saveItem',
            ACTION_SET_EDIT_ITEM: 'problem/setEditItem',
            ROUTE_LIST: 'problemsList',
            STORE_MODULE: 'problem'
        }
    },
    async created() {
        this.$store.commit('task/setOptimizeItem', null);
        this.$store.commit('task/setPredictItem', null);
        this.$store.commit('task/setWellsItem', null);
        this.$store.commit('grid/resetData');

        if (this.itemId) {
            await this.load();
            await this.$store.dispatch(this.ACTION_SET_EDIT_ITEM, this.itemId);
            await this.$store.dispatch('task/setOptimizeItem', this.itemId);
            await this.$store.dispatch('task/setPredictItem', this.itemId);
            await this.$store.dispatch('task/setWellsItem', this.itemId);
        }
    },
    watch: {
        async itemId() {
            this.$store.commit('grid/resetData');
            await this.load();
        },
        storeTask: {
            deep: true,
            handler() {
                if (typeof (this.storeTask) !== 'undefined') {
                    this.task = this.storeTask;
                }
            }
        },
        storePredictTask: {
            deep: true,
            handler() {
                if (typeof (this.storePredictTask) !== 'undefined') {
                    if (!this.storePredictTask?.predict) {
                        return;
                    }
                    this.predictTask = this.storePredictTask;
                }
            }
        },
        storeWellsTask: {
            deep: true,
            handler() {
                if (typeof (this.storeWellsTask) !== 'undefined') {
                    this.wellsTask = this.storeWellsTask;
                }
            }
        },
        stepCode() {
            this.gotoStep(this.stepCode);
        }
    },
    methods: {
        async save() {
            let item = clone(this.item);
            if (!item.reservoir) {
                item.reservoir = {}
            }

            if (!item.wells) {
                item.wells = [];
            }

            await this.$store.dispatch(this.ACTION_SAVE, item);
        },
        async load() {
            let item = await this.$store.dispatch('problem/loadItem', this.itemId);
            console.log('load', item);
            if (item?.problem) {
                this.item = item?.problem;
                this.editState = item?.state;

                if (item?.tasks && item?.tasks?.length > 0) {
                    let task = item?.tasks[0];
                    if (task.type === 'base') {
                        this.task = task
                    }

                    if (task.type === 'predict') {
                        this.predictTask = task;
                    }

                    if (task.type === 'wells') {
                        this.wellsTask = task;
                    }
                }
            }
            else if (item) {
                this.item = item;
            }
            console.log('load', this.item, this.editState);
        },
        async saveTask() {
            if (!this.task) {
                return;
            }

            if (this.task.id) {
                this.task.status = null;
                await this.$store.dispatch('task/saveItem', this.task);
            }
            else {
                await this.$store.dispatch('task/newItem', this.task);
            }
        },
        async savePredictTask() {
            if (!this.predictTask) {
                return;
            }

            if (this.predictTask.id) {
                this.predictTask.status = null;
                await this.$store.dispatch('task/saveItem', this.predictTask);
            }
            else {
                await this.$store.dispatch('task/newItem', this.predictTask);
                await this.$store.dispatch('task/loadItems', {problemId: this.task.problemId});
                await this.$store.dispatch('task/setPredictItem', this.task.problemId);
            }
        },
        async saveWellsTask() {
            if (!this.wellsTask) {
                return;
            }

            if (this.wellsTask.id) {
                this.wellsTask.status = null;
                await this.$store.dispatch('task/saveItem', this.wellsTask);
            }
            else {
                await this.$store.dispatch('task/newItem', this.wellsTask);
                await this.$store.dispatch('task/loadItems', {problemId: this.wellsTask.problemId});
                await this.$store.dispatch('task/setWellsItem', this.wellsTask.problemId);
            }
        },
        async onFileChanged(e) {
            this.files = e.target.files;
            await this.upload();
        },
        async loadToBrowser(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.readAsArrayBuffer(file);
                reader.onload = () => resolve(reader.result);
                reader.onerror = error => reject(error);
            });
        },
        async readFile(file) {
            if (!file) {
                return;
            }

            file.buffer = await this.loadToBrowser(file);
            return file;
        },
        async upload() {
            this.uploadedFiles = [];
            for (let file of this.files) {
                let fileWithData = await this.readFile(file);
                this.uploadedFiles.push(fileWithData);
            }
        },
        showSelectFileDialog() {
            this.isSelectingFiles = true;

            window.addEventListener('focus', () => {
                this.isSelectingFiles = false;
            }, { once: true });

            this.$refs.uploader.click();
        },
        async saveTaskAndGotoNextStep() {
            if (this.item?.type === 'wells') {
                await this.saveWellsTask();
            }
            else {
                await this.saveTask();
            }
            this.gotoNextStep();
        },
        gotoNextStep() {
            this.gotoStepNumber(this.step + 1);
        },
        gotoStepNumber(nextStep) {
            let nextStepData = this.steps.find(item => item.step === nextStep);
            if (nextStepData) {
                this.gotoStep(nextStepData.code);
            }
        },
        gotoStep(stepCode) {
            try {
                if (stepCode === 'predict') {
                    this.$router.push({name: 'viewResult', params: {id: this.item.id}});
                }
                else {
                    this.$router.push({name: 'problemEdit', params: {id: this.item.id, step: stepCode}});
                }
            }
            catch (e) {
                return e;
            }
        },
        getStepByCode(stepCode) {
            return this.steps.find(item => item.code === stepCode);
        },
        isPreviousFinished(stepCode) {
            let currentStep = this.getStepByCode(stepCode);
            let previousStep = this.steps.find(step => step.step === currentStep.step - 1);
            if (!previousStep) {
                return false;
            }

            return this.isStepFinished(previousStep);
        },
        isStepEditable(step) {
            if (this.isStepFinished(step)) {
                return true;
            }

            let isEditable = false;
            switch (step.code) {
                case 'problem':
                    isEditable = true;
                    break;
                case 'settings':
                case 'adapt':
                case 'predict':
                case 'wells':
                    isEditable = this.isPreviousFinished(step.code);
                    break;
                default:
                    isEditable = false;
                    break;
            }

            return isEditable;
        },
        isStepFinished(step) {
            let isFinished = false;
            switch (step.code) {
                case 'problem':
                    isFinished = this.inputValid;
                    break;
                case 'settings':
                    isFinished = this.settingsValid;
                    break;
                case 'adapt':
                    isFinished = this.taskFinished;
                    break;
                case 'predict':
                    isFinished = this.predictTaskFinished;
                    break;
                case 'wells':
                    isFinished = this.wellsTaskFinished;
                    break;
                default:
                    isFinished = this.step > step.step;
                    break;
            }

            return isFinished;
        },
        gotoList() {
            return this.$router.push({name: this.ROUTE_LIST});
        }
    },
    computed: {
        itemId() {
            return this.$route.params && this.$route.params.id
                ? this.$route.params.id || false
                : false;
        },
        storeTask() {
            return this.$store.state.task.optimize;
        },
        storePredictTask() {
            return this.$store.state.task.predict;
        },
        storeWellsTask() {
            return this.$store.state.task.wells;
        },
        typeSteps() {
            return this.$store.state.problem.typeSteps;
        },
        steps() {
            let type = this.item?.type || 'base';
            return this.typeSteps[type];
        },
        stepCode() {
            return this.$route.params.step || false;
        },
        step() {
            if (!this.stepCode) {
                return 1;
            }

            let stepData = this.steps.find(item => item.code === this.stepCode);
            if (!stepData) {
                return 1;
            }

            return stepData.step;
        },
        taskFinished() {
            return this.task && this.task.status && this.task.status === 'finished';
        },
        predictTaskFinished() {
            return this.predictTask && this.predictTask.status && this.predictTask.status === 'finished';
        },
        wellsTaskFinished() {
            return this.wellsTask && this.wellsTask.status && this.wellsTask.status === 'finished';
        },
        inputValid() {
            if (!this.item) {
                return false;
            }

            let isGridValid = this.item.reservoir &&
                this.item.reservoir.grids_x > 0 &&
                this.item.reservoir.grids_y > 0 &&
                this.item.reservoir.grids_z > 0 &&
                this.item.reservoir.dx > 0 &&
                this.item.reservoir.dy > 0 &&
                this.item.reservoir.dz > 0;

            let isShapeValid = (this.item.k_mean_permeability > 0 && this.item.phi_mean_porosity > 0) ||
                (this.item.wells && this.item.wells.every(well => well.k_well_permeability > 0 && well.phi_well_porosity > 0));

            let isWellsValid = this.item.wells && this.item.wells.length > 0;
            let isSwSoValid = this.item.s_iw_irreducible_water_saturation > 0 && this.item.s_or_residual_oil_saturation > 0;
            let isPValid = this.item.p_reservoir_pressure > 0;
            let isFluidValid = this.item.mu_o_oil_viscosity > 0 && this.item.mu_w_water_viscosity > 0;

            let isRockValid = this.item.co_oil_compressibility > 0 &&
                this.item.cr_rock_compressibility > 0 &&
                this.item.cw_water_compressibility > 0;

            let isInjectionDataValid = this.item.injection_data && Object.keys(this.item.injection_data).length > 0;
            let isHistoryDataValid = this.item.history_data && Object.keys(this.item.history_data).length > 0;

            return isGridValid && isShapeValid && isWellsValid && isSwSoValid && isPValid &&
                isFluidValid && isRockValid && isInjectionDataValid && isHistoryDataValid;
        },
        settingsValid() {
            return this.task && this.task.params && this.task.params.n_ensemble > 0;
        },
        storeEditState() {
            return this.$store.state.problem.editState;
        },
    }
}
</script>

<style lang="scss">
    .problem-edit {
        height: 100%;
        position: relative;

        .v-stepper, .v-stepper__items, .v-stepper__content, .v-stepper__wrapper {
            height: 100%;
        }

        .v-stepper__items {
            padding-bottom: 144px;
        }
    }
</style>
